// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TitleBorder_wrap__iqQv7","wrap-left":"TitleBorder_wrap-left__UhG_8"};